import {
    CopyContainer,
    StyledContactCard,
    StyledContactCardContent,
    StyledPhoto,
    Wrapper,
} from "./ContactCard.styles";
import React, { useState } from "react";

import HStack from "shared/components/layout/stack/HStack";
import PropTypes from "prop-types";
import TertiaryButton from "shared/components/inputs/button/TertiaryButton";
import Text from "shared/components/data-display/text/Text";
import VStack from "shared/components/layout/stack/VStack";
import env from "react-dotenv";

export { CopyContainer } from "./ContactCard.styles";

const ContactCard = ({
    photoUrl = "",
    name,
    jobPost,
    department,
    location,
    slackId,
    emailId,
    contactCardLabel = "Talent Manager",
    contactCardLabelVariant = "Descriptive_1_1",
    contactCardLabelColor = "Gray_2",
    actionProps = {},
    actionIconWidth = 16,
    hasAction = false,
    actionIcon,
}) => {
    const [copy, setCopy] = useState("Copy");
    const copyToClipboard = (e) => {
        e.preventDefault();
        if (navigator?.clipboard) {
            navigator.clipboard.writeText(emailId);
            setCopy("Copied");
        }
    };
    return (
        <Wrapper spacing="Zero_5">
            <HStack>
                <Text
                    variant={contactCardLabelVariant}
                    color={contactCardLabelColor}
                >
                    {contactCardLabel}
                </Text>
                {hasAction && (
                    <TertiaryButton
                        {...actionProps}
                        leadingIcon={actionIcon}
                        iconWidth={actionIconWidth}
                        style={{
                            color: "currentColor",
                            background: "transparent",
                        }}
                    />
                )}
            </HStack>
            <StyledContactCard
                spacing="Zero_75"
                align="flex-start"
                className="contact-card"
            >
                <VStack>
                    <StyledPhoto url={photoUrl} alt={name} />
                </VStack>
                <StyledContactCardContent>
                    <VStack spacing="Zero_25">
                        <Text variant="Headline_5" color="Black">
                            {name}
                        </Text>
                        <Text variant="Descriptive_1_1" color="Gray_2">
                            {jobPost}, {department}
                        </Text>
                        <Text variant="Descriptive_1_1" color="Gray_3">
                            {location}
                        </Text>
                    </VStack>
                    <VStack spacing="Zero">
                        {slackId && (
                            <CopyContainer align="center" spacing="Zero_25">
                                <TertiaryButton
                                    leadingIcon="slack-logo"
                                    label={slackId}
                                    href={`slack://user?team=${env.BESTWORK_REACT_SLACK_TEAM_ID}&id=U0AGBSQTY`}
                                    target="_blank"
                                    rel="noreferrer"
                                />
                                <Text
                                    variant="Body_2_1"
                                    className="textMassage"
                                    color="Gray_2"
                                >
                                    Message
                                </Text>
                            </CopyContainer>
                        )}
                        {emailId && (
                            <CopyContainer align="center" spacing="Zero_25">
                                <TertiaryButton
                                    leadingIcon="mail"
                                    label={emailId}
                                    onClick={(e) => {
                                        copyToClipboard(e);
                                    }}
                                />
                                <Text
                                    variant="Body_2_1"
                                    className="textMassage"
                                    color="Gray_2"
                                >
                                    {copy}
                                </Text>
                            </CopyContainer>
                        )}
                    </VStack>
                </StyledContactCardContent>
            </StyledContactCard>
        </Wrapper>
    );
};

ContactCard.propTypes = {
    photoUrl: PropTypes.string,
    name: PropTypes.string,
    jobPost: PropTypes.string,
    department: PropTypes.string,
    location: PropTypes.string,
    slackId: PropTypes.string,
    emailId: PropTypes.string,
    contactCardLabel: PropTypes.string,
    contactCardLabelVariant: PropTypes.string,
    contactCardLabelColor: PropTypes.string,
    actionProps: PropTypes.object,
    actionIconWidth: PropTypes.number,
    hasAction: PropTypes.bool,
    actionIcon: PropTypes.string,
};

export default ContactCard;
